const PREFIX = "praxpay_avatar_";

export const getAvatarKey = (user: any): string | null => {
  const email = user?.email ? String(user.email).trim().toLowerCase() : null;
  if (email) return `${PREFIX}${email}`;
  if (user?.id) return `${PREFIX}id_${user.id}`;
  return null;
};

const legacyKeys = (user: any): string[] => {
  const keys: string[] = [];
  if (user?.id) keys.push(`${PREFIX}${user.id}`);
  if (user?.email) keys.push(`${PREFIX}${user.email}`);
  keys.push(`${PREFIX}user`);
  return keys;
};

export const loadAvatar = (user: any): string | null => {
  const key = getAvatarKey(user);
  if (!key) return null;
  try {
    const current = localStorage.getItem(key);
    if (current) return current;
    for (const legacy of legacyKeys(user)) {
      if (legacy === key) continue;
      const value = localStorage.getItem(legacy);
      if (value) {
        try {
          localStorage.setItem(key, value);
        } catch (e) {}
        return value;
      }
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const saveAvatar = (user: any, dataUrl: string): boolean => {
  const key = getAvatarKey(user);
  if (!key) return false;
  try {
    localStorage.setItem(key, dataUrl);
    return true;
  } catch (e) {
    return false;
  }
};

export const removeAvatar = (user: any): void => {
  const key = getAvatarKey(user);
  try {
    if (key) localStorage.removeItem(key);
    for (const legacy of legacyKeys(user)) localStorage.removeItem(legacy);
  } catch (e) {}
};
